import Text from 'components/Text';
import { style } from 'constant/constants';
import { Grid, Stack } from '../../node_modules/@mui/material/index';
import { Link } from 'react-router-dom';
import { isAreaAdmin, isSuperAdmin } from 'utils/utils';
import { useSelector } from 'react-redux';

const Error = () => {
  const { userData } = useSelector((store) => store.auth);
  const backLink =
    isAreaAdmin(userData?.roles) || isSuperAdmin(userData?.roles)
      ? '/Stores'
      : '/StoreInfo/projects';
  return (
    <Grid>
      <Stack
        style={{
          color: style.LIGHT.primary,
          marginRight: '10vh',
          marginTop: '20vh'
        }}>
        <Text variant="h4" textAlign="center">
          An error occurred!
        </Text>
      </Stack>

      <Text variant="h6" textAlign="center" style={{ marginRight: '9vh', marginTop: '2vh' }}>
        An error occurred due to unexpected request, <br /> Please navigate
        <Link variant="text" to={backLink}>
          <span
            style={{
              color: style.LIGHT.primary,
              fontFamily: style.fontFamily,
              textDecoration: 'underline',
              marginLeft: '1vh',
              marginRight: '1vh'
            }}>
            back
          </span>
        </Link>
        to site.
      </Text>
    </Grid>
  );
};

export default Error;
